import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box } from '@mui/material';

interface MarkdownPreviewProps {
  content: string;
}

const MarkdownPreview: React.FC<MarkdownPreviewProps> = ({ content }) => {
  // Convert wikilinks [[target]] → **target** for display
  const processed = content.replace(/\[\[([^\]]+)\]\]/g, '**$1**');

  return (
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        p: 2,
        '& h1': { fontSize: '1.8rem', fontWeight: 600, mt: 0 },
        '& h2': { fontSize: '1.5rem', fontWeight: 600 },
        '& h3': { fontSize: '1.25rem', fontWeight: 600 },
        '& p': { lineHeight: 1.6 },
        '& code': {
          bgcolor: 'action.hover',
          px: 0.5,
          py: 0.25,
          borderRadius: 0.5,
          fontFamily: 'monospace',
          fontSize: '0.85em',
        },
        '& pre': {
          bgcolor: 'action.hover',
          p: 2,
          borderRadius: 1,
          overflow: 'auto',
          '& code': { bgcolor: 'transparent', p: 0 },
        },
        '& blockquote': {
          borderLeft: 4,
          borderColor: 'primary.main',
          pl: 2,
          ml: 0,
          color: 'text.secondary',
        },
        '& ul, & ol': { pl: 3 },
        '& a': { color: 'primary.main' },
        '& table': {
          width: '100%',
          borderCollapse: 'collapse',
          '& th, & td': {
            border: 1,
            borderColor: 'divider',
            p: 1,
          },
        },
        '& img': { maxWidth: '100%' },
        '& hr': { borderColor: 'divider' },
      }}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{processed}</ReactMarkdown>
    </Box>
  );
};

export default MarkdownPreview;
